/* global window, document */
if (!window._babelPolyfill) {
	require('@babel/polyfill')
}

import React from 'react'
import ReactDOM from 'react-dom'
import GiveawaysEditor from './containers/GiveawaysEditor.jsx'

document.addEventListener('DOMContentLoaded', function () {
	ReactDOM.render(
		<GiveawaysEditor wpObject={window.twppwr_object} />,
		document.getElementById('tiket-on-wordpress-giveawayseditor')
	)
})
